import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NoCreditCardsAlert = ({ clientId, show }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {t('CONTRACT_VIEW.CONTRACT_DETAIL.CREDIT_CARD_NO_CARDS_MESSAGE')}
      {clientId && (
        <>
          {' '}
          <Link
            to={`/clients/detail/${clientId}/billing/bank_account`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('CONTRACT_VIEW.CONTRACT_DETAIL.GO_TO_BANK_ACCOUNTS')}
          </Link>
        </>
      )}
    </Alert>
  );
};

NoCreditCardsAlert.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool.isRequired
};

export default NoCreditCardsAlert;

